import type { MetadataJson } from 'libphonenumber-js/core';

import _parsePhoneNumber from 'libphonenumber-js/core';

import metadata from './libphonenumberjs.metadata.json';

export const parsePhoneNumber = (phoneNumber: string) => _parsePhoneNumber(phoneNumber, metadata as MetadataJson);
